import { BrowserModule,Title } from '@angular/platform-browser';
import { NgModule,ErrorHandler,APP_INITIALIZER   } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { SideNavOuterToolbarModule, SideNavInnerToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, LoginFormModule } from './shared/components';
import { AuthService, ScreenService, AppInfoService,HelperService} from './shared/services';
import { AppRoutingModule } from './app-routing.module';
import { DevExtremeModule } from 'devextreme-angular';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CustomInterceptor,DataAccessService } from './shared/services/dataaccess.service';
import { Configuration } from './app.constants';
import {ForgetPasswordPageComponent} from "./studentportal/components/forget-password/forget-password-page.component";
import {RegistrationformComponent} from "./studentportal/components/Registration/registrationform.component";
import { StudentverifywithprnComponent } from './studentportal/components/Registration/studentverifywithprn.component';
import { MeritlinkComponent } from './studentportal/components/Registration/meritlink.component';

import {ChecklistRegistrationInfoComponent} from "./studentportal/components/Registration/checklist-registration-info.component";
import {ChecklistcontactComponent} from "./studentportal/components/Registration/checklistcontact.component";
import { ChecklistRegistrationwithprnInfoComponent } from './studentportal/components/Registration/checklist-registrationwithprn-info.component';

import {GlobalErrorHandlerService} from './shared/ErrorHandler/global-error-handler.service';


import {AppConfigService} from './app-config.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
//import { Fileupload14Component } from './shared/components/fileupload14/fileupload14.component';

//import { Fileupload11Component } from './shared/components/fileupload11/fileupload11.component';
//import { Fileupload10Component } from './shared/components/fileupload10/fileupload10.component';
//import { Fileupload7Component } from './shared/components/fileupload7/fileupload7.component';
//import { Fileupload8Component } from './shared/components/fileupload8/fileupload8.component';
//import { Fileupload9Component } from './shared/components/fileupload9/fileupload9.component';
//import { Documentview8Component } from './shared/components/documentview8/documentview8.component';
//import { Fileupload6Component } from './shared/components/fileupload6/fileupload6.component';
//import { Fileupload5Component } from './shared/components/fileupload4/fileupload5/fileupload5.component';
//import { Fileupload4Component } from './shared/components/fileupload4/fileupload4.component';
//import { Document7Component } from './shared/components/documentview7/documentview7.component';
//import { Documentview6Component } from './shared/components/documentview6/documentview6.component';
//import { Fileupload3Component } from './shared/components/fileupload3/fileupload3.component';
//import { Documentview5Component } from './shared/components/documentview5/documentview5.component';
//import { Documentview4Component } from './shared/components/documentview4/documentview4.component';
//import { Fileupload2Component } from './shared/components/fileupload2/fileupload2.component';
//import { Documentview3Component } from './shared/components/documentview3/documentview3.component';
//import { Fileupload1Component } from './shared/components/fileupload1/fileupload1.component';


// import {provide} from '@angular/cdk';
// import {
//   ROUTER_PROVIDERS,
//   LocationStrategy,
//   HashLocationStrategy
// } from '@angular/router';


@NgModule({
  declarations: [
    AppComponent,
    ForgetPasswordPageComponent,
    RegistrationformComponent,
    ChecklistRegistrationInfoComponent,
    ChecklistcontactComponent,
    ChecklistRegistrationwithprnInfoComponent,
    StudentverifywithprnComponent,
    MeritlinkComponent,
   // Fileupload14Component,
   // Fileupload11Component,
   // Fileupload10Component,
   // Fileupload7Component,
   // Fileupload8Component,
   // Fileupload9Component
   // Documentview8Component,
    //Fileupload6Component,
   // Fileupload5Component,
   // Fileupload4Component
    //Document7Component,
    //Documentview6Component,
    //Fileupload3Component,
    //Documentview5Component,
    //Documentview4Component,
    //Fileupload2Component,
    //Documentview3Component,
   // Fileupload1Component,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SlimLoadingBarModule.forRoot(),
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    LoginFormModule,
    DevExtremeModule,

    AppRoutingModule,
    BrowserAnimationsModule,
    PasswordStrengthMeterModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          //Make sure to return a promise!
          return appConfigService.loadAppConfig();
        };
      }
    },AuthService, ScreenService, AppInfoService,Configuration,DataAccessService,HelperService,{
    provide: HTTP_INTERCEPTORS,
    useClass: CustomInterceptor,
    multi: true,
  },GlobalErrorHandlerService,{ provide: ErrorHandler, useClass: GlobalErrorHandlerService },Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
